export const escapeRegexString = (str: string): string => str.replace(/[.*+?^${}()|\[\]\\]/g, "\\$&");

export const KEYWORDS_DELIMITER_REGEX_PATTERN = "%[0-9a-f]{2}|[^\\p{L}\\p{N}]";
export const KEYWORDS_DELIMITER_REGEX_PATTERN_START = `^|${KEYWORDS_DELIMITER_REGEX_PATTERN}`;
export const KEYWORDS_DELIMITER_REGEX_PATTERN_END = `${KEYWORDS_DELIMITER_REGEX_PATTERN}|$`;
